import { type PropsWithChildren } from 'react';
import { ScrollView } from 'react-native';

// ─────────────────────────────────────────────────────────────────────────────

export const AddToBagUnavailableIngredientsContent = (props: PropsWithChildren) => {
  const { children } = props;

  return <ScrollView>{children}</ScrollView>;
};
